import { Button, Dialog, DialogContent, DialogTrigger, Tooltip } from '@civilgrid/ui/components';
import { useState } from 'react';
import { useSnapshot } from 'valtio';
import store from '../store';
import AgencyContactCards from '../UtilityContacts/AgencyContactCards';

export default function ContactsDialog({ disabled = false }: { disabled?: boolean }) {
  const { project } = useSnapshot(store) as typeof store;
  const [open, setOpen] = useState(false);
  // Utilities reloading closes the list, and it stays closed once loading finishes.
  if (disabled && open) setOpen(false);

  // The trigger stays the same element while disabled, so keyboard focus survives loading finishing.
  return (
    <Dialog open={open} onOpenChange={(next) => setOpen(next && !disabled)}>
      <Tooltip asChild text="Contacts open once utilities finish loading" isDisabled={!disabled}>
        <DialogTrigger asChild>
          <Button
            variant={disabled ? 'disabled' : 'secondary'}
            aria-disabled={disabled || undefined}
            data-testid="utilities-top-nav-contacts"
          >
            Contacts
          </Button>
        </DialogTrigger>
      </Tooltip>
      <DialogContent
        title="Utility Contacts"
        description={project && `Email contacts for the agencies on ${project.name}.`}
        className="h-[min(86vh,720px)] max-h-[min(86vh,720px)] max-w-[620px]"
        // Escape in a search box with text clears the search first, so it keeps the dialog open.
        onEscapeKeyDown={(event) => {
          if (event.target instanceof HTMLInputElement && event.target.value.trim()) event.preventDefault();
        }}
        data-testid="utilities-contacts-dialog"
      >
        <AgencyContactCards />
      </DialogContent>
    </Dialog>
  );
}
